import React from 'react'
// import { TbArrowNarrowRight } from "react-icons/tb";
import { EnterpreneurSvg, ItConsultantSvg, SalesSvg, SoftwareSvg } from '../svg';
import students from "../../../images/surge-collges/impact.webp"

export default function Impact() {
    const [position, setPosition] = React.useState(window.innerWidth <= 645);

    React.useEffect(() => {
        window.onresize = function () {
            setPosition(window.innerWidth <= 645);
        };
    }, []);
    return (
        <div className='mt-[30px] sm:mt-[80px] relative'>
            <div className='bg-[#F0FBF8] w-full px-[20px] rounded-[30px] sm:rounded-[60px] py-[25px] sm:py-[80px]'>
                <h4 className='text-[#0F0200] font-bold text-[21px] sm:text-[40px] xl:text-[50px] text-center'>The Impact</h4>
                {/* <h5 className='mt-[12px] sm:mt-[24px] font-normal text-[#000000] text-[14px] sm:text-[18px] xl:text-[24px] text-center'>WorkFast AI Franchise is designed for driven individuals and businesses who <br className='hidden lg:block' /> want to participate in the AI revolution and build a recurring revenue stream.</h5> */}
                <div className='mt-[20px] sm:mt-[46px] px-[20px] sm:px-0 w-full sm:w-10/12 mx-auto grid xl:grid-cols-2 gap-[20px] sm:gap-[40px] lg:gap-[77px] justify-center items-center'>
                    <div>
                        <div className='flex gap-[20px] sm:gap-[32px] text-start sm:items-center'>
                            <div className='size-[44px] sm:size-[64px] shrink-0 flex justify-center items-center rounded-[14px] sm:rounded-[21px]' style={{ boxShadow: "0px 0px 4px 0px #FF950099" }}>
                                <EnterpreneurSvg size={position ? "20" : "36"} />
                            </div>
                            <div>
                                <p className='text-[#292D34] font-semibold text-[12px] sm:text-[18px]'>Boost employability with guaranteed internships</p>
                            </div>
                        </div>
                        <div className='flex gap-[20px] sm:gap-[32px] text-start sm:items-center mt-[20px] sm:mt-[42px]'>
                            <div className='size-[44px] sm:size-[64px] shrink-0 flex justify-center items-center rounded-[14px] sm:rounded-[21px]' style={{ boxShadow: "0px 0px 4px 0px #34C75999" }}>
                                <ItConsultantSvg size={position ? "26" : "36"} />
                            </div>
                            <div>
                                <p className='text-[#292D34] font-semibold text-[12px] sm:text-[18px]'>Position your college as a national innovation hub</p>
                            </div>
                        </div>
                        <div className='flex gap-[20px] sm:gap-[32px] text-start sm:items-center  mt-[20px] sm:mt-[42px]'>
                            <div className='size-[44px] sm:size-[64px] shrink-0 flex justify-center items-center rounded-[14px] sm:rounded-[21px]' style={{ boxShadow: "0px 0px 4px 0px #218BFF99" }}>
                                <SoftwareSvg size={position ? "26" : "36"} />
                            </div>
                            <div>
                                <p className='text-[#292D34] font-semibold text-[12px] sm:text-[18px]'>Empower students to become founders</p>
                            </div>
                        </div>
                        <div className='flex gap-[20px] sm:gap-[32px] text-start sm:items-center  mt-[20px] sm:mt-[42px]'>
                            <div className='size-[44px] sm:size-[64px] shrink-0 flex justify-center items-center rounded-[14px] sm:rounded-[21px]' style={{ boxShadow: "0px 0px 4px 0px #AF52DE99" }}>
                                <SalesSvg size={position ? "26" : "36"} />
                            </div>
                            <div>
                                <p className='text-[#292D34] font-semibold text-[12px] sm:text-[18px]'>Build faculty expertise in cutting-edge domains</p>
                            </div>
                        </div>
                    </div>
                    <img src={students} alt='banner' loading='lazy' className='w-full rounded-[20px] h-[450px] object-cover' />
                </div>
                {/* <p className='xl:mt-[46px] text-[#000000] text-[18px] sm:text-[24px] font-medium text-center px-[20px] sm:px-0'>🌟 Whether you’re starting fresh or expanding your business portfolio, <br className='hidden lg:block' /> WorkFast AI equips you with the tools, training, and support to succeed.</p> */}
            </div>
            {/* <div className='bg-[#E4F8F2] w-full rounded-b-[30px] sm:rounded-b-[60px] py-[20px] flex justify-center items-center gap-[15px] sm:gap-[23px] cursor-pointer text-[14px] sm:text-[20px] font-semibold text-[#292D34]'>
                <h6>Apply Now & Secure Your Pincode</h6>
                <TbArrowNarrowRight className='text-[#00B884]' />
            </div> */}
        </div>

    )
}
